'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeLogMessages');

var KayleeLogMessages = {
    fromJson: fromJson,
    getLogMessages: getLogMessages,
};

function fromJson(data) {
    var reqProps = [ '$logId' ];
    return FirebaseArray.$fromJson(data, 'LogMessages', reqProps, reqProps,
        function(data) { return getLogMessages(data.$logId); }
    );
}

// Returns a promise that resolves to the LogMessages object when it is loaded.

function getLogMessages(logId) {
    var key = 'Log Messages: ' + logId;
    var messages = KayleeCache.get(key);

    if (messages === null) {
        messages = new LogMessages(logId);
        KayleeCache.put(key, messages);
    }

    return messages;
}

function LogMessages(logId) {
    this.$nodeType = 'logMessages';
    this.$logId = logId;
    FirebaseArray.call(this,
        KayleeBase.app.database().ref('logs/messages/' + logId));
    KayleeUtil.bindPrototypeMethods(LogMessages.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;

}

LogMessages.prototype = Object.create(FirebaseArray.prototype);
LogMessages.prototype.constructor = LogMessages;

LogMessages.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this,
        [ '$logId' ], {});
};

LogMessages.prototype.toString = function() {
    return '[Log Messages (' + this.$id + ')]';
};

module.exports = KayleeLogMessages;
